import { apiFetch } from "./client";

const BASE = "/patient/statistiques";

export type Period = "30j" | "60j" | "90j" | "6m" | "9m" | "12m" | "1a";

export interface HistoriqueMedicalData {
  period: string;
  consultations: {
    total: number;
    enCours: number;
    derniereConsultation: {
      date: string;
      typeConsultation: string;
      statutConsultation: string;
      etatSortie: string;
    } | null;
    parType: Record<string, number>;
    etatsSortie: {
      gueri: number;
      en_traitement: number;
      sorti_sans_avis_medical: number;
      decede: number;
      sans_etat: number;
    };
  };
  ordonnances: { total: number };
  analyses: { total: number; avecResultats: number };
  vaccinations: { total: number };
  dossierMedical: {
    present: boolean;
    statut: string | null;
    numeroDossier: string | null;
  };
}

export async function fetchHistoriqueMedical(
  period: Period
): Promise<{ ok: true; data: HistoriqueMedicalData } | { ok: false; status: number; message: string }> {
  const res = await apiFetch<{ data?: HistoriqueMedicalData }>(`${BASE}/historique-medical?period=${period}`);
  if (!res.ok) return res;
  const inner = res.data?.data;
  if (!inner?.consultations) return { ok: false, status: 0, message: "Structure de réponse inattendue." };
  return { ok: true, data: inner };
}
